import React, { Dispatch, SetStateAction, useState } from "react";
import ModalLayout from "../../../../components/ModalLayout";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import TruckCheck from "../../../../../media/images/icons/truck-check";
import { blueGrey } from "@mui/material/colors";
import TruckFillSVG from "../../../../../media/images/icons/truck-fill";
import CustomAutoComplete from "../../../../components/CustomAutoComplete";
import CustomButton from "../../../../components/CustomButton";
import CheckCircle from "../../../../../media/images/icons/check-circle";
import { useAppSelector } from "../../../../../hooks/useRedux";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ChangeLoaderGroupModal(props: Props) {
  const { open, setOpen } = props;

  const [loaderGroupInputValue, setloaderGroupInputValue] = useState("");

  const loaderTypeGroup = useAppSelector(
    (state) => state.user.vehicleInfo?.loaderTypeGroup
  );
  const loaderTypeName = useAppSelector(
    (state) => state.user.vehicleInfo?.loaderTypeName
  );

  const theme = useTheme();
  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}
        >
          <TruckCheck color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
              color: "primary.main",
            }}
          >
            تغییر گروه بارگیر
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <Box
            sx={{
              borderColor: blueGrey[400],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              backgroundColor: "bgColor.white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <TruckFillSVG />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                نوع بارگیر:{" "}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                {loaderTypeName}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              borderColor: blueGrey[400],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              backgroundColor: "bgColor.white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <TruckFillSVG />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                گروه بارگیر فعلی شما{" "}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                {loaderTypeGroup}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider variant="fullWidth" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            گروه بارگیر جدید را انتخاب کنید:
          </Typography>
          <CustomAutoComplete
            mb="0px"
            inputValue={loaderGroupInputValue}
            setInputValue={setloaderGroupInputValue}
            type={"loaderType"}
            placeHolder="نوع بارگیر"
            //   setValue={handleChangeAutoComplete}
            //   value={loaderTypeInfoFormik.values.loaderType}
            // error={loaderType.error}
            // errorMessage={loaderType.errorMessage}
            //   options={loaderTypeInputValue ? loaderTypesOptions : []}
            // innerIcon={
            //   <LocationOutline size={18} color={theme.palette.textColor.light} />
            // }
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            // loading={loading}
            //   onClick={() => setOpenChangeLoaderGroup(true)}
            flex={1}
            flexDirection="row"
            title="ذخیره گروه بارگیر"
            justifyContent="center"
            bgColor="success.main"
            fSize="16px"
            fWeight="700"
            px="6px"
            py="12px"
            borderRadius="6px"
            icon1={<CheckCircle color={"#fff"} size={24} />}
            mt="0px"
          />
          <CustomButton
            // loading={loading}
            onClick={() => setOpen(false)}
            flexDirection="row"
            borderColor="primary.main"
            title="انصراف"
            justifyContent="center"
            textColor="primary.main"
            bgColor="#fff"
            fSize="16px"
            fWeight="700"
            px="20px"
            py="8px"
            borderRadius="6px"
            mt="0px"
          />
        </Box>
      </Box>
    </ModalLayout>
  );
}
